<template>
  <customerbalanadjust-check
    :sna-id="snaId"
    :data.sync="checkDataInfo"
  >
   <template #footer>
      <check-module :title="`审批`">
        <check-handle-module
          :pass-dialog-txt="`审批通过客户余额将进行调整并生成。`"
          :check-from-data="checkFromData"
          @submitCheck="submitCheck"
          :submitDisable='submitDisable'
        ></check-handle-module>
      </check-module>
   </template>
  </customerbalanadjust-check>
</template>

<script>
import CustomerbalanadjustCheck
  from '@/views/workbench/workCheckManage/customerbalanadjustCheck/customerbalanadjustCheck'
import checkMixin from '@/mixin/checkMixin'
import checkApi from '@/api/workbench/check'
export default {
  name: 'customerbalanadjustCheckView',
  mixins: [checkMixin],
  components: { CustomerbalanadjustCheck },
  data () {
    return {
      submitDisable: false,
      checkDetailName: 'customerbalanadjustcheckdetail'
    }
  },
  methods: {
    submitCheck (form) {
      this.submitDisable = true
      const params = this.formatCheckParams(form)
      params.customerBalanceApproval = this.checkDataInfo
      checkApi.submitCustomerbalanadjustCheck(params).then(res => {
        this.goCheckDetail(res)
        this.submitDisable = false
      })
    }
  }
}
</script>

<style scoped>

</style>
